import { Box, Text } from '@wix/design-system';
import React from 'react';
import { RunTaskEntryStatus, RunTaskEntryType } from '../../constants';
import { ApprovalRequest } from './ApprovalRequest';
import { AutomationTrigger } from './AutomationTrigger';
import { Feedback } from './Feedback';
import { SkeletonLoader } from './SkeletonLoader';
import { StatusIcon } from './StatusIcon';
import { TimeStatus } from './TimeStatus';
import { TriggeredStatus } from './TriggeredStatus';
import { ViewDetailsIcon } from './ViewDetailsIcon';
export const EntryItem = _ref => {
  let {
    entry,
    resolvedApprovalIds,
    invocationId,
    metaSiteId,
    onApprove,
    onReject,
    onEditApproval,
    onViewDetails,
    onTimeout
  } = _ref;
  const showTrigger = entry.type === RunTaskEntryType.Trigger;
  const showStatusIcon = !showTrigger;
  const showToolMessage = entry.type === RunTaskEntryType.ToolCall && !!entry.message;
  const showSummaryMessage = entry.type === RunTaskEntryType.End && !!entry.message;
  const showFeedback = entry.type === RunTaskEntryType.End && !!invocationId && !!metaSiteId;
  const showTimeStatus = !!showTrigger && (entry.status === RunTaskEntryStatus.Pending || entry.hasTimedOut);
  const showTriggeredStatus = !!showTrigger && [RunTaskEntryStatus.Loading, RunTaskEntryStatus.Succeeded].includes(entry.status);
  const shouldUseLightMessage = entry.type === RunTaskEntryType.ToolCall && entry.inProgress && !entry.requiresApproval && !entry.approvalId;
  const showViewDetails = !!entry.requestPayload || !!entry.resultPayload;
  const showApproval = entry.type === RunTaskEntryType.ToolCall && entry.requiresApproval && !!entry.approvalId && !resolvedApprovalIds.has(entry.approvalId) && entry.status === RunTaskEntryStatus.Pending;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    backgroundColor: "D80",
    border: "1px solid",
    borderColor: "B40",
    borderRadius: 8,
    padding: "SP2",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    minHeight: 24
  }, showStatusIcon && /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(StatusIcon, {
    status: entry.status
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    direction: "vertical",
    verticalAlign: "middle",
    gap: "SP2"
  }, entry.type === RunTaskEntryType.Loading ? /*#__PURE__*/React.createElement(SkeletonLoader, null) : /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold",
    overflowWrap: "anywhere"
  }, entry.title)), showViewDetails && /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(ViewDetailsIcon, {
    onViewDetails: onViewDetails
  }))), showTrigger && /*#__PURE__*/React.createElement(AutomationTrigger, {
    appName: entry.automation.appName,
    triggerName: entry.automation.triggerName,
    iconUrl: entry.automation.iconUrl
  }), showTimeStatus && /*#__PURE__*/React.createElement(TimeStatus, {
    hasTimedOut: entry.hasTimedOut,
    onTimeout: onTimeout
  }), showTriggeredStatus && /*#__PURE__*/React.createElement(TriggeredStatus, null), showToolMessage && /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "SP5"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    overflowWrap: "anywhere",
    secondary: shouldUseLightMessage,
    light: shouldUseLightMessage
  }, entry.message)), showApproval && /*#__PURE__*/React.createElement(Box, {
    paddingLeft: "SP5",
    marginTop: "SP1"
  }, /*#__PURE__*/React.createElement(ApprovalRequest, {
    entry: entry,
    onApprove: onApprove,
    onReject: onReject,
    onEditApproval: onEditApproval
  })), showSummaryMessage && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    overflowWrap: "anywhere"
  }, entry.message), showFeedback && /*#__PURE__*/React.createElement(Feedback, {
    metaSiteId: metaSiteId,
    invocationId: invocationId
  }));
};
//# sourceMappingURL=EntryItem.js.map